import RefreshIcon from "@mui/icons-material/Refresh";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";
import type { SxProps } from "@mui/material/styles";

type WordProcessorErrorStateProps = {
  readonly height: number | undefined;
  readonly sx?: SxProps;
};

export default function WordProcessorErrorState({
  height = 400,
  sx
}: WordProcessorErrorStateProps) {
  return (
    <Box
      sx={{
        height: height ? `${height - 30}px` : undefined,
        border: `solid 2px ${grey[200]}`,
        padding: "24px",
        borderRadius: "8px",
        userSelect: "none",
        width: "calc(100% - 20px)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        backgroundColor: grey[50],
        ...sx
      }}
    >
      <Typography
        variant="h5"
        sx={{
          color: grey[700],
          marginBottom: "8px",
          fontWeight: 500
        }}
      >
        Unable to Load Editor
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: grey[600],
          marginBottom: "16px",
          maxWidth: "400px",
          lineHeight: 1.5
        }}
      >
        The text editor failed to load its required resources. This might be due
        to a network issue or server problem.
      </Typography>

      <Button
        variant="contained"
        startIcon={<RefreshIcon />}
        onClick={() => window.location.reload()}
        sx={{
          backgroundColor: "#054743",
          "&:hover": {
            backgroundColor: "#043a37"
          },
          textTransform: "none",
          fontWeight: 500,
          minWidth: "200px"
        }}
      >
        Reload Page
      </Button>
    </Box>
  );
}
